module.exports = __webpack_public_path__ + "static/media/p_11_1.7dd3574f.png";